import React from "react";
import BlogFortyFive from "../component/BlogFortyFive";

function BlogFortyFiveContainer() {
  return <BlogFortyFive />;
}

export default BlogFortyFiveContainer;
